import { Col, Row } from "react-bootstrap";
import {
  Container,
  DadosContainer,
  ResumoContainer,
  TextoClaro,
  TextoNegrito,
} from "./style";

interface IInfoEmplacamento {
  categoria: string;
  usuarioSolicitante: string;
  pendencias: string | null;
}
export function ModalInfoEmplacamento({
  dados,
}: Readonly<{
  dados: IInfoEmplacamento;
}>) {
  const pendencias = dados.pendencias
    ? dados.pendencias
        .split(",")
        .map((pendencia) => pendencia.trim())
        .filter(Boolean)
    : [];

  return (
    <Container>
      <TextoClaro>Informações</TextoClaro>
      <ResumoContainer>
        <Row>
          <Col>
            <DadosContainer>
              <span>Categoria</span>
              <TextoNegrito>{dados.categoria ?? "-"}</TextoNegrito>
            </DadosContainer>
          </Col>
          <Col>
            <DadosContainer>
              <span>Usuário solicitante</span>
              <TextoNegrito>{dados.usuarioSolicitante ?? "-"}</TextoNegrito>
            </DadosContainer>
          </Col>
        </Row>
        {pendencias.length > 0 && (
          <Row>
            <Col>
              <DadosContainer>
                <span>Pendências vinculadas</span>
                {pendencias.map((pendencia, index) => (
                  <TextoNegrito key={`${index}-${pendencia}`}>{pendencia}</TextoNegrito>
                ))}
              </DadosContainer>
            </Col>
          </Row>
        )}
      </ResumoContainer>
    </Container>
  );
}
